<script setup lang="ts">
import VText from "@magnit/core/src/components/VText/VText.vue";

defineProps<{
  count: number;
}>();

const emit = defineEmits<{
  reset: [];
}>();
</script>

<template>
  <div class="filter-count-clear">
    <VText font="body-large-accent"> Выбрано {{ count }} </VText>
    <VText
      font="body-large-accent"
      :color="count ? 'primary' : 'secondary'"
      @click="emit('reset')"
    >
      Сбросить
    </VText>
  </div>
</template>

<style scoped lang="postcss">
.filter-count-clear {
  display: flex;
  justify-content: space-between;
  padding: var(--pl-unit-x3) 0;
}
</style>
